export const needsFilteredScan = page => page?.scan_complete === false && page.has_more === true && Boolean(page.next_cursor);

// Each server response already bounds its provider work. Keep a second bound
// on automatic client continuation; after this, the cursor is manual Load more.
export async function continueFilteredScan({ first, initialIds = [], current, fetchNext, append }) {
  const ids = new Set([...initialIds, ...first.items.map(item => item.id)]);
  const cursors = new Set();
  let page = first;
  for (let attempts = 0; attempts < 6 && ids.size < 100 && needsFilteredScan(page.page) && current(); attempts += 1) {
    const cursor = page.page.next_cursor;
    if (cursors.has(cursor)) break;
    cursors.add(cursor);
    page = await fetchNext(cursor);
    if (!current()) return;
    page.items.forEach(item => ids.add(item.id));
    append(page);
  }
}
